import Data from '@/data'
import Trans from '@/data/trans'
import { SelectOption } from '@/ui/select'
import { notNull } from '@/utils/validation'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import HoverNumber from '../editor/HoverNumber'
import { ItemProps } from './ItemEditor'
import { AbstractCategory } from './category'
import { SelectLine } from './select'

export function ItemClusterJewel({ item, onChange }: ItemProps) {
  const onChangeNodes = React.useCallback(
    (value: number) =>
      onChange((item) => {
        const base = Data.items[item.base]
        if (!base.cluster_jewel || item.unique) return item
        value = Math.min(
          base.cluster_jewel.max_skills,
          Math.max(base.cluster_jewel.min_skills, Math.round(value))
        )
        if (value === item.clusterJewel?.nodes) return item
        return {
          ...item,
          clusterJewel: {
            nodes: value,
            skill:
              item.clusterJewel?.skill ||
              base.cluster_jewel.passive_skills[0].id
          }
        }
      }),
    [onChange]
  )
  const onChangeSkill = React.useCallback(
    (opt?: SelectOption<string>) =>
      opt &&
      onChange((item) => {
        const base = Data.items[item.base]
        if (!base.cluster_jewel || item.unique) return item
        if (!Data.passive_skills[opt.id]) return item
        if (!base.cluster_jewel.passive_skills.find((sk) => sk.id === opt.id))
          return item
        return {
          ...item,
          clusterJewel: {
            nodes: item.clusterJewel?.nodes ?? base.cluster_jewel.min_skills,
            skill: opt.id
          }
        }
      }),
    [onChange]
  )

  const base = Data.items[item.base]
  const skillOptions = React.useCallback(() => {
    if (!base?.cluster_jewel) return []
    return base.cluster_jewel.passive_skills
      .map((sk) => {
        const skill = Data.passive_skills[sk.id]
        if (!skill) return
        return {
          id: sk.id,
          name: Trans.global.formatStats(skill.stats).join('\n')
        }
      })
      .filter(notNull)
  }, [base])

  if (!base?.cluster_jewel || item.unique) return null

  const nodes = item.clusterJewel?.nodes ?? base.cluster_jewel.min_skills
  const skill =
    item.clusterJewel?.skill ?? base.cluster_jewel.passive_skills[0].id

  return (
    <AbstractCategory name="Enchant">
      <li className="poe-StatLine">
        <div className="poe-stat-contents">
          <div>
            Adds{' '}
            <HoverNumber
              value={nodes}
              onChange={onChangeNodes}
              min={base.cluster_jewel.min_skills}
              max={base.cluster_jewel.max_skills}
            />{' '}
            Passive Skills
          </div>
        </div>
      </li>
      {base.cluster_jewel.size === 'Large' && (
        <li className="poe-StatLine">
          <div className="poe-stat-contents">
            <div>2 Added Passive Skills are Jewel Sockets</div>
          </div>
        </li>
      )}
      {base.cluster_jewel.size === 'Medium' && (
        <li className="poe-StatLine">
          <div className="poe-stat-contents">
            <div>1 Added Passive Skill is a Jewel Socket</div>
          </div>
        </li>
      )}
      <li className="poe-StatLine">
        <SelectLine id={skill} options={skillOptions} onChange={onChangeSkill}>
          {(expanded) => (
            <>
              <div>
                {Trans.global
                  .formatStats(Data.passive_skills[skill]?.stats ?? {})
                  .map((line) => `Added Small Passive Skills grant: ${line}`)
                  .join('\n')}
              </div>
              {!expanded && (
                <div className="poe-mods-info">
                  <FontAwesomeIcon icon={faChevronDown} className="poe-arrow" />
                </div>
              )}
            </>
          )}
        </SelectLine>
      </li>
    </AbstractCategory>
  )
}
